const siteUrl = apidae_editor_map_data.siteUrl;
const hot =
	siteUrl + "/wp-content/plugins/wp-apidae/assets/images/map-style/hot.png";
const osmfr =
	siteUrl + "/wp-content/plugins/wp-apidae/assets/images/map-style/osmfr.png";
const GeoportailFrance =
	siteUrl + "/wp-content/plugins/wp-apidae/assets/images/map-style/ign.png";
const GeoportailFrancePhoto =
	siteUrl + "/wp-content/plugins/wp-apidae/assets/images/map-style/photo.png";

const themes = [
	{
		id: 1,
		name: "Hot",
		image: hot,
	},
	{
		id: 2,
		name: "OsmFr",
		image: osmfr,
	},
	{
		id: 3,
		name: "Geoportail France",
		image: GeoportailFrance,
	},
	{
		id: 4,
		name: "Geoportail France Photo",
		image: GeoportailFrancePhoto,
	},
];

export default themes;
